import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import paginate from "./paginate.module"

import pages from "./pages.module"
import categories from "./categories.module"
import products from "./products.module"
import attributes from "./attributes.module"
import attributesOptions from "./attributesOptions.module"
import variations from "./variations.module"
import orders from "./orders.module"
import clients from "./clients.module"
import search from "./search.module"
import users from "./users.module"
import dashboard from "./dashboard.module"
import files from "./files.module"
import cities from "./cities.module"
import home from "./home.module"
import setting from "./settings.module"


import alert from "./alert.module"


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    paginate,

    pages,
    categories,
    products,
    attributes,
    attributesOptions,
    variations,
    alert,
    orders,
    clients,
    search,
    users,
    dashboard,
    files,
    cities,
    home,
    setting

  }
});
